export default __webpack_public_path__ + "static/media/hero-bcg2.f9cd3140.jpg";